import { render, staticRenderFns } from "./correction.vue?vue&type=template&id=c3b9bc94&"
import script from "./correction.vue?vue&type=script&lang=js&"
export * from "./correction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports